var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,{"meta":_vm.metaByProp}),(Boolean(_vm.metaByProp.version))?_vm._t(_vm.metaByProp.version,null,null,_vm.metaByProp):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }